import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Container = styled.div`
  position: relative;
  display: inline-block;
  .ant-popover-arrow {
      top: 34px !important;
    }
`;

export const HoverButton = styled.div`
  outline: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  border-radius: 50px;
  background-color: #ffeb3b;
  border: #ffeb3b;
  color: #000;
  min-width: 150px;
  height: 32px;
  padding: 0 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const PopupContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  .ant-radio-wrapper,
  .ant-radio-inner,
  .ant-radio-checked .ant-radio-inner {
    border-color: #917bf7 !important;
  }

  .ant-radio-inner {
    border-color: #917bf7;
  }

  .ant-radio-inner::after {
    background-color: #917bf7;
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #917bf7;
  }
`;

export const SampleSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #444;
`;

export const StyledDivider = styled.div`
  height: 1px;
  width: 100%;
  background: #f0f0f0;
  margin: 10px 0;
  border-radius: 1px;
`;

export const ActionButton = styled.div`
  outline: 0;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
  border-radius: 5px;
  background-color: ${({ type }) => (type === 'filled' ? '#917bf7' : '')};
  border: 1px solid #917bf7;
  color: ${({ type }) => (type === 'filled' ? '#fff ' : '#917bf7')};
  min-width: 150px;
  height: 32px;
  padding: 0 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;